import React from "react";
import styled from "styled-components";
import LaiYinSeries from "../LaiYinSeries";
import LingGanSeries from "../LingGanSeries";

/**
 * 首页：把两条品牌线的内容合并成同一个可爬取的文档。
 *
 * GEO 的考虑是：搜索引擎与 AI 引擎抓取官网时通常只取首页，
 * 单页合并能让品牌、产品矩阵、团队、资质、荣誉这些实体在同一份 HTML 里互相印证；
 * 各系列页仍保留独立 URL（供既有外链和导航使用），首页用锚点定位到对应区块。
 */
export default function Homepage() {
  return (
    <Wrapper>
      <Section id="laiyin-series">
        <LaiYinSeries heroTitleLevel="h1" />
      </Section>
      <Section id="linggan-series">
        {/* 合并页只保留一个 h1，灵敢区块的标题降级为 h2 */}
        <LingGanSeries heroTitleLevel="h2" />
      </Section>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Section = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
